/* eslint-disable react/no-danger */

/**
 * Libs
 * */
import { convert } from 'html-to-text';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
    ISectionConfiguration,
    WizardStateAbout,
} from 'src/features/common/universe-wizard/context/wizard-context.types';

/**
 * Components
 * */
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Button } from 'src/ui/common/atoms/button';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';
import { getUrlWithPublicStorage } from 'src/utils/get-url-with-public-host';
import { useRenderAboutSidebar } from '../../hooks/use-render-about-sidebar';
import { StyledAboutUniverse, StyledDescription } from './about-universe.styles';

export const AboutUniverse: React.FC<ISectionConfiguration<WizardStateAbout>> = (props) => {
    const { previewImage, websiteLink, title, description, fullDescription, websiteLinkEnabled, previewImageEnabled } =
        props;
    const { t } = useTranslation(['pages']);
    const screen = useScreenDetect();
    const renderSidebar = useRenderAboutSidebar(props);

    const onReadMore = useCallback(() => {
        renderSidebar();
    }, [renderSidebar]);

    const fullDescriptionText = useMemo(() => convert(fullDescription ?? ''), [fullDescription]);

    const showReadMore =
        fullDescriptionText || (websiteLink && websiteLinkEnabled) || (previewImage && previewImageEnabled);

    return (
        <StyledAboutUniverse padding="0 0 80px" paddingMd="120px 0">
            <Grid xs={1} sm={previewImage && previewImageEnabled ? 2 : 1}>
                {previewImage && previewImageEnabled && (
                    <Spacing mb="40px" mbSm="0" mrSm="24px" mrMd="64px">
                        <img src={getUrlWithPublicStorage(previewImage)} alt="whitelabel preview" />
                    </Spacing>
                )}
                <FlexBox flexDirection="column">
                    <Spacing mb="24px" mbMd="32px" pt="0" ptMd="24px">
                        <Typography variant="title" color="gs200" size={screen.xs || screen.sm ? 'xs' : 'sm'} uppercase>
                            {title || t('home.universeAbout.title')}
                        </Typography>
                    </Spacing>
                    <Spacing mb="30px" mbMd="56px">
                        <Typography variant="title" size={screen.xs || screen.sm ? 'base' : 'md'} color="white">
                            <StyledDescription dangerouslySetInnerHTML={{ __html: description ?? '' }} />
                        </Typography>
                    </Spacing>
                    {showReadMore && (
                        <Button variant="outline" stretch={screen.xs || screen.sm} onClick={onReadMore}>
                            {t('home.universeAbout.readMore')}
                        </Button>
                    )}
                </FlexBox>
            </Grid>
        </StyledAboutUniverse>
    );
};
